import Api from '../api';
const { axios: api } = Api;

const PREFIX = 'file';

export const getFile = async (payload) => {
	const data = await api.get(`/${PREFIX}/${payload}?base64=true`);
	
	return { data: data?.data };
};
